export default {
  fields: [{
      name: 'file',
      label: "Fichier",
      type: 'file',
      isHtml: true,
      link: (context, value) => value ? process.env.BACK_FILES_URL + value : null,
      linkTarget: '_blank',
      formatter: (context, value) => value ? '<a href="' + process.env.BACK_FILES_URL + value + '">' + value + '</a>' : null
    },
    {
      name: 'type_slug',
      label: "Type",
      type: 'select',
      formatter: (context, value) => value ? context.$store.getters['stored_file/getType'](value) ? context.$store.getters['stored_file/getType'](value).text : null : null
    },
    {
      name: 'format',
      label: "Format",
      type: 'text',
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/StoredFile/config.js